import { gql } from "@apollo/client";

export const LEGAL_MENTIONS_QUERY = gql`
  query LegalMentions {
    legalMention {
      content
    }
  }
`
